<oui-select
  label="Assureur"
  [options]="assureurOptions"
  (valueChange)="onAssureurChange($event)"
  [control]="form.get('assureurId')"></oui-select>

<oui-select
  label="Type RCP"
  [multiple]="true"
  [options]="rcpMultiOptions"
  [control]="form.get('rcpType')"></oui-select>

<oui-date-picker
  label="Date de début"
  placeholder="JJ/MM/AAAA"
  [control]="this.form.get('dateDebutValidite')"></oui-date-picker>
